import { createReducer } from '@reduxjs/toolkit';

import changeRequestInProgress from './actions';

export default createReducer(false, {
  [changeRequestInProgress]: (state, { payload: isRequestInProgress }) =>
    isRequestInProgress,
});
